export const env = import.meta.env.MODE

export const endpoints = {
  api: import.meta.env.VITE_API_URL,
}

const apiUrl = String(endpoints.api ?? '')

export const environmentLabel = apiUrl.includes('localhost')
  ? 'LOCAL'
  : apiUrl.includes('sandbox')
    ? 'SANDBOX'
    : null
